import { styled } from "styled-components";
import { FaUniversity } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";

import HomeHeading from "../../components/HomeHeading";
import HomeContainerWrapper from "../../components/HomeContainerWrapper";
import profile from "../../assets/images/profile.webp";

export default function About() {
  return (
    <Container id="about">
      <HomeContainerWrapper>
        <HomeHeading>About Me</HomeHeading>

        <Intro>
          <div className="intro-details">
            <div className="about">
              <p>
                I build full-stack applications, backend systems, cloud
                infrastructure, and AI/ML. I care about clean design and writing
                code that still makes sense to whoever opens it next, including
                future me. Lately, that's meant spending most of my time at the
                intersection of core infrastructure and LLMs, building and
                integrating the systems that connect them.
              </p>
              <div className="education">
                <div className="education-item">
                  <div className="education-timeline">
                    <span className="year">2016</span>

                    <span className="timeline-line">
                      <span className="timeline-dot start-dot" />
                      <span className="timeline-dot end-dot" />
                    </span>

                    <span className="year">2020</span>
                  </div>

                  <div className="education-content">
                    <div className="education-details">
                      <FaUniversity />

                      <div className="education-text">
                        <div className="degree-row">
                          <span className="degree">Bachelor&apos;s</span>

                          <GoDotFill className="degree-separator" />

                          <span className="field">
                            Computer Science and Engineering
                          </span>
                        </div>

                        <span className="institution">
                          SRM Institute of Science and Technology, India
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="education-item">
                  <div className="education-timeline">
                    <span className="year">2025</span>

                    <span className="timeline-line">
                      <span className="timeline-dot start-dot" />
                      <span className="timeline-dot end-dot" />
                    </span>

                    <span className="year">2026</span>
                  </div>

                  <div className="education-content">
                    <div className="education-details">
                      <FaUniversity />

                      <div className="education-text">
                        <div className="degree-row">
                          <span className="degree">Master&apos;s</span>

                          <GoDotFill className="degree-separator" />

                          <span className="field">Computer Science</span>
                        </div>

                        <span className="institution">
                          Arizona State University, USA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="profile">
              <img src={profile} alt="Sivasanker Nandakumar Padmapriya" />
            </div>
          </div>
        </Intro>
      </HomeContainerWrapper>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;

  p {
    font-size: 14px;
    color: #ababab;
    line-height: 1.7em;
    text-align: justify;
    font-weight: 300;
  }

  h3 {
    color: #fff;
    font-size: 34px;
    text-align: center;
    margin-bottom: 30px;
    font-weight: 500;
    user-select: none;
  }

  .education {
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 50px;
    margin-top: 50px;
  }

  .education-item {
    width: 100%;
    display: grid;
    grid-template-columns: 55px minmax(0, 1fr);
    column-gap: 20px;
    align-items: stretch;
    min-height: 125px;
  }

  /*
   * LEFT SIDE
   * Year + vertical line + year
   */
  .education-timeline {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    min-height: 125px;
  }

  .year {
    color: #777;
    font-size: 13px;
    font-weight: 400;
    line-height: 1;
    flex-shrink: 0;
  }

  .timeline-line {
    position: relative;
    width: 1px;
    flex: 1;
    min-height: 65px;
    margin: 10px 0;
    background: #343434;
  }

  .timeline-dot {
    position: absolute;
    left: 50%;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #777;
  }

  .start-dot {
    top: 0;
    transform: translate(-50%, -50%);
  }

  .end-dot {
    bottom: 0;
    transform: translate(-50%, 50%);
  }

  /*
   * RIGHT SIDE
   * Vertically centers the education details
   * against the full height of the timeline.
   */
  .education-content {
    min-width: 0;
    display: flex;
    align-items: center;
  }

  .education-details {
    display: flex;
    align-items: flex-start;
    gap: 15px;
    width: 100%;

    > svg {
      color: #fff;
      font-size: 18px;
      flex-shrink: 0;
      margin-top: 3px;
    }
  }

  .education-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
  }

  .degree-row {
    display: flex;
    align-items: center;
    gap: 7px;
    min-width: 0;
  }

  .degree {
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    flex-shrink: 0;
  }

  .degree-separator {
    color: #555 !important;
    font-size: 10px !important;
    flex-shrink: 0;
    margin: 0 !important;
  }

  .field {
    color: #ababab;
    font-size: 14px;
    font-weight: 300;
  }

  .institution {
    color: #777;
    font-size: 14px;
    line-height: 1.6;
    font-weight: 300;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 24px;
    }

    .education {
      max-width: 100%;
      gap: 42px;
      margin-top: 50px;
    }

    .education-item {
      grid-template-columns: 42px minmax(0, 1fr);
      column-gap: 16px;
      min-height: 110px;
    }

    .education-timeline {
      min-height: 110px;
    }

    .year {
      font-size: 11px;
    }

    .timeline-line {
      min-height: 55px;
      margin: 8px 0;
    }

    .education-details {
      gap: 13px;

      > svg {
        font-size: 16px;
        margin-top: 2px;
      }
    }

    .degree-row {
      gap: 5px;
      flex-wrap: wrap;
    }

    .degree {
      font-size: 14px;
    }

    .field {
      font-size: 12px;
    }

    .degree-separator {
      font-size: 8px !important;
    }

    .institution {
      font-size: 12px;
    }
  }
`;

const Intro = styled.div`
  display: flex;
  flex-direction: column;

  div.profile {
    width: 360px;
    flex-shrink: 0;

    img {
      display: block;
      object-fit: contain;
      width: 100%;
      margin-left: auto;
      border-radius: 15px;
    }
  }

  .intro-details {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    user-select: none;
    gap: 80px;
  }

  .about {
    flex: 1;
    min-width: 0;
  }

  p {
    margin: 0;
    color: #ababab;
    font-size: 18px;
    line-height: 2em;
    font-weight: 300;
    text-align: left;
  }

  @media (max-width: 998px) {
    .intro-details {
      gap: 50px;
    }

    div.profile {
      width: 310px;
    }
  }

  @media (max-width: 768px) {
    .intro-details {
      flex-direction: column-reverse;
      align-items: center;
      gap: 45px;

      .profile {
        width: 100%;
        max-width: 250px;
      }

      .about {
        width: 100%;
      }

      p {
        font-size: 13px;
        line-height: 1.9em;
      }
    }
  }
`;
